"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class OrchestrationClientInputData {
    constructor(taskHubName, creationUrls, managementUrls, baseUrl, requiredQueryStringParameters, rpcBaseUrl) {
        this.taskHubName = taskHubName;
        this.creationUrls = creationUrls;
        this.managementUrls = managementUrls;
        this.baseUrl = baseUrl;
        this.requiredQueryStringParameters = requiredQueryStringParameters;
        this.rpcBaseUrl = rpcBaseUrl;
    }
    static isOrchestrationClientInputData(obj) {
        const typedInstance = obj;
        if (typedInstance) {
            if (typedInstance.taskHubName !== undefined &&
                typedInstance.creationUrls !== undefined &&
                typedInstance.managementUrls !== undefined) {
                return true;
            }
            return false;
        }
        return false;
    }
}
exports.OrchestrationClientInputData = OrchestrationClientInputData;
//# sourceMappingURL=orchestrationclientinputdata.js.map